<template>
  <span class="product-awards-headline">
    {{ headline }}
  </span>
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import pigeon from '../../utilities/js/pigeon/pigeon';

  @Options({
    name: 'product-awards-headline'
  })
  export default class ProductAwardsHeadline extends Vue {
    @Prop()
    text: string;

    count: number = 0;

    mounted() {
      pigeon.subscribe('productAwards:updateCount', (val: number) => {
        this.count = val;
      });
    }

    get headline() {
      return this.text.replace('{0}', this.count.toString());
    }
  }
</script>
